import { render, staticRenderFns } from "./resetPw_vn.vue?vue&type=template&id=77680d8b&scoped=true&"
import script from "./resetPw_vn.vue?vue&type=script&lang=js&"
export * from "./resetPw_vn.vue?vue&type=script&lang=js&"
import style0 from "./resetPw_vn.vue?vue&type=style&index=0&id=77680d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77680d8b",
  null
  
)

export default component.exports